import React from 'react'
import Masonry from 'react-masonry-component';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-apollo-hooks'

import { ItemListLoading } from '../../../components'
import { CountriesQuery, ICountry } from '../../../store'

export const Countries = () => {
    const { t, i18n: { languages: [language] } } = useTranslation()
    const { data, loading } = useQuery(CountriesQuery, {
        variables: {
            language
        }
    })
    let sliderProps = {
        dots: true,
        centerMode: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerPadding: '15px',
        arrows: false,
        adaptiveHeight: true,
        infinite: false,
        speed: 200,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    };
    const adds = false;
    return (
        <>
            <div className="body-wrapper item-list-wrapper clearfix">
            {loading
                ? <ItemListLoading key="loading" />
                : <Masonry className="item-list-container">
                    {data.countries && data.countries.map((item: ICountry) => {
                        const { images: countryImages = [] } = CountryImages.find(({id}) => id === item.id) || {};
                        const imagePath: string = countryImages.length ? countryImages[Math.floor((Math.random() * countryImages.length))] : '';
                        const tourPath = {
                            pathname: `/${language}/${item.slug}`,
                            state: {
                                country: item
                            }
                        }
                        return (
                            <div key={item.id} className="item" >
                                {!adds &&
                                    <Link to={tourPath}>
                                        <div className="item-wrapper">
                                            <div className="item-image">
                                                <img src={imagePath} alt={item.title} />
                                                <div className="overlay">
                                                    <span className="cta cta-rounded cta-small">{t('View Tours')}</span>
                                                </div>
                                            </div>
                                            <div className="item-detail">
                                                <h4>{item.title}</h4>
                                            </div>
                                        </div>
                                    </Link>
                                }
                                {adds &&
                                    <div className="item-wrapper">
                                        <a href="/" >
                                            <img src={imagePath} alt={item.title} />
                                        </a>
                                    </div>
                                }
                            </div>
                        )
                    }
                    )}
                </Masonry>
            }
            </div>
            <section className="section-near-by">
                <div className="row">
                    <div className="columns medium-12">
                        <h5>{t('Near By')}</h5>
                        <Slider {...sliderProps} className="nearby-carousel">
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/hotels-icon.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Hotels')}
                                    </div>
                                </div>
                            </div>
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/hotels-icon.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Hotels')}
                                    </div>
                                </div>
                            </div>
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/vilas.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Villas')}
                                    </div>
                                </div>
                            </div>
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/activities-icon.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Tourist Attractions')}
                                    </div>
                                </div>
                            </div>
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/rental-icon.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Rental')}
                                    </div>
                                </div>
                            </div>
                            <div className="nearby-item">
                                <div className="near-by-list">
                                    <div className="near-by-list-icon">
                                        <img src="/images/icons/flights-icon.png" alt="mp" />
                                    </div>
                                    <div className="near-by-list-content">
                                        {t('Flights')}
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
        </>
    );
}

const CountryImages = [
    {
        id: 1,
        images: [
            '/images/countries/360T_DominicanRepublic1_300_400.png',
            '/images/countries/360T_DominicanRepublic2_300_400.png',
            '/images/countries/360T_DominicanRepublic3_300_400.png'
        ]
    },
    {
        id: 6,
        images: [
            '/images/countries/Spain10_300_400.jpg',
            '/images/countries/Spain11_300_400.jpg',
            '/images/countries/Spain12_300_400.jpg',
            '/images/countries/Spain1_300_400.jpg',
            '/images/countries/Spain2_300_400.jpg',
            '/images/countries/Spain3_300_400.jpg',
            '/images/countries/Spain4_300_400.jpg',
            '/images/countries/Spain5_300_400.jpg',
            '/images/countries/Spain6_300_400.jpg',
            '/images/countries/Spain7_300_400.jpg',
            '/images/countries/Spain8_300_400.jpg',
            '/images/countries/Spain9_300_400.jpg'
        ]
    },
    {
        id: 7,
        images: [
            '/images/countries/Greece1_300_400.jpg',
            '/images/countries/Greece2_300_400.jpg',
            '/images/countries/Greece3_300_400.jpg'
        ]
    },
    {
        id: 8,
        images: [
            '/images/countries/360T_Andorra2_300_400.png',
            '/images/countries/Andorra1_300_400.png'
        ]
    },
    {
        id: 9,
        images: [
            '/images/countries/Romania10_300_400.jpg',
            '/images/countries/Romania1_300_400.jpg',
            '/images/countries/Romania2_300_400.jpg',
            '/images/countries/Romania3_300_400.jpg',
            '/images/countries/Romania4_300_400.jpg',
            '/images/countries/Romania5_300_400.jpg',
            '/images/countries/Romania6_300_400.jpg',
            '/images/countries/Romania7_300_400.jpg',
            '/images/countries/Romania8_300_400.jpg',
            '/images/countries/Romania9_300_400.jpg'
        ]
    },
    {
        id: 10,
        images: [
            '/images/countries/Austria1_300_400.jpg',
            '/images/countries/Austria2_300_400.jpg',
            '/images/countries/Austria3_300_400.jpg',
            '/images/countries/Austria4_300_400.jpg'
        ]
    },
    {
        id: 11,
        images: [
            '/images/countries/Germany1_300_400.jpg',
            '/images/countries/Germany2_300_400.jpg',
            '/images/countries/Germany3_300_400.jpg',
            '/images/countries/Germany4_300_400.jpg'
        ]
    },
    {
        id: 12,
        images: [
            '/images/countries/Egypt1_300_400.jpg',
            '/images/countries/Egypt2_300_400.jpg',
            '/images/countries/Egypt3_300_400.jpg'
        ]
    },
    {
        id: 13,
        images: [
            '/images/countries/Italy1_300_400.jpg',
            '/images/countries/Italy2_300_400.jpg',
            '/images/countries/Italy3_300_400.jpg',
            '/images/countries/Italy4_300_400.jpg'
        ]
    },
    {
        id: 14,
        images: [
            '/images/countries/Switzerland10_300_400.jpg',
            '/images/countries/Switzerland11_300_400.jpg',
            '/images/countries/Switzerland1_300_400.jpg',
            '/images/countries/Switzerland2_300_400.jpg',
            '/images/countries/Switzerland3_300_400.jpg',
            '/images/countries/Switzerland4_300_400.jpg',
            '/images/countries/Switzerland5_300_400.jpg',
            '/images/countries/Switzerland6_300_400.jpg',
            '/images/countries/Switzerland7_300_400.jpg',
            '/images/countries/Switzerland8_300_400.jpg',
            '/images/countries/Switzerland9_300_400.jpg'
        ]
    },
    {
        id: 15,
        images: [
            '/images/countries/Indonesia1_300_400.jpg',
            '/images/countries/Indonesia2_300_400.jpg',
            '/images/countries/Indonesia3_300_400.jpg',
            '/images/countries/Indonesia4_300_400.jpg',
            '/images/countries/Indonesia5_300_400.jpg'
        ]
    },
    {
        id: 16,
        images: [
            '/images/countries/Maldives1_300_400.jpg',
            '/images/countries/Maldives2_300_400.jpg',
            '/images/countries/Maldives3_300_400.jpg',
            '/images/countries/Maldives4_300_400.jpg'
        ]
    },
    {
        id: 17,
        images: [
            '/images/countries/USA1_300_400.jpg',
            '/images/countries/USA2_300_400.jpg',
            '/images/countries/USA3_300_400.jpg',
            '/images/countries/USA5_300_400.jpg',
            '/images/countries/USA6_300_400.jpg',
            '/images/countries/USA7_300_400.jpg',
            '/images/countries/USA8_300_400.jpg',
            '/images/countries/USA9_300_400.jpg'
        ]
    },
    {
        id: 19,
        images: [
            '/images/countries/Canada1_300_400.jpg',
            '/images/countries/Canada2_300_400.jpg',
            '/images/countries/Canada3_300_400.jpg'
        ]
    },
    {
        id: 20,
        images: [
            '/images/countries/Seychelles1_300_400.jpg',
            '/images/countries/Seychelles2_300_400.jpg',
            '/images/countries/Seychelles3_300_400.jpg'
        ]
    },
    {
        id: 21,
        images: [
            '/images/countries/Mexico1_300_400.jpg',
            '/images/countries/Mexico2_300_400.jpg',
            '/images/countries/Mexico3_300_400.jpg',
            '/images/countries/Mexico4_300_400.jpg',
            '/images/countries/Mexico5_300_400.jpg'
        ]
    },
    {
        id: 23,
        images: [
            '/images/countries/LaReunion1_300_400.jpg'
        ]
    },
    {
        id: 25,
        images: [
            '/images/countries/China1_300_400.jpg',
            '/images/countries/China2_300_400.jpg'
        ]
    },
    {
        id: 27,
        images: [
            '/images/countries/Moldavia1_300_400.jpg',
            '/images/countries/Moldavia2_300_400.jpg',
            '/images/countries/Moldavia3_300_400.jpg',
            '/images/countries/Moldavia4_300_400.jpg',
            '/images/countries/Moldavia5_300_400.jpg',
            '/images/countries/Moldavia6_300_400.jpg'
        ]
    },
    {
        id: 28,
        images: [
            '/images/countries/Oman1_300_400.jpg',
            '/images/countries/Oman2_300_400.jpg',
            '/images/countries/Oman3_300_400.jpg',
            '/images/countries/Oman4_300_400.jpg'
        ]
    },
    {
        id: 29,
        images: [
            '/images/countries/Colombia1_300_400.jpg',
            '/images/countries/Colombia2_300_400.jpg'
        ]
    },
    {
        id: 30,
        images: [
            '/images/countries/Qatar1_300_400.jpg',
            '/images/countries/Qatar2_300_400.jpg'
        ]
    },
    {
        id: 31,
        images: [
            '/images/countries/CostaRica1_300_400.jpg',
            '/images/countries/CostaRica2_300_400.jpg'
        ]
    },
    {
        id: 32,
        images: [
            '/images/countries/Denmark1_300_400.jpg',
            '/images/countries/Denmark2_300_400.jpg'
        ]
    }
]